<template>
    <b-row>
        <b-col md="12">
            <component-header
                title="Return & Cancellation Policy"
                @search-query="(val) => (filter = val)"
                :hasClear="false"
                @create-press="$router.push({ path: '/setup/policy/create' })"
                @reload-data="getReturnPolicyList"
                createButtonText="Add Return & Cancellation Policy"
                :isLoading="loading"
            />
        </b-col>
        <b-col md="12">
            <b-card class="custome-card">
                <div>
                    <b-table
                        :dark="false"
                        :hover="true"
                        :striped="false"
                        :bordered="true"
                        :small="false"
                        :fixed="false"
                        responsive="sm"
                        :items="fetchReturnPolicy"
                        :fields="returnPolicyFields"
                        :current-page="currentPage"
                        :per-page="perPage"
                        thead-class="header"
                        @filtered="onFilter"
                        :filter="filter"
                        show-empty
                        :busy="loading"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >
                        <template slot="cell(createdAt)" slot-scope="data">
                            <div>{{ data.item.createdAt | formatedate }}</div>
                        </template>
                        <template slot-scope="data" slot="cell(action)">
                            <div class="d-flex">
                                <div>
                                    <b-button
                                        size="sm"
                                        class="mr-2 button-circle"
                                        variant="primary"
                                        @click="returnPolicyView(data.item)"
                                    >
                                        <i class="fas fa-eye"></i>
                                    </b-button>
                                </div>
                                <div>
                                    <b-button
                                        size="sm"
                                        class="mr-2 button-circle"
                                        style="
                                            background: #fe7b08;
                                            border: #fe7b08;
                                        "
                                        Coupon
                                        Code
                                        variant="primary"
                                        @click="returnPolicyEdit(data.item)"
                                    >
                                        <i class="fas fa-pencil-alt"></i>
                                    </b-button>
                                </div>
                                <div>
                                    <b-button
                                        size="sm"
                                        class="mr-2 button-circle"
                                        variant="danger"
                                        @click="deleteReturnPolicy(data.item)"
                                    >
                                        <i class="fas fa-trash-alt"></i>
                                    </b-button>
                                </div>
                            </div>
                        </template>
                        <template slot="cell(empty)">
                            <div v-if="loading" class="text-center">
                                <span><b>Loading...</b></span>
                            </div>
                            <div v-else class="text-center">
                                No data available.
                            </div>
                        </template>
                    </b-table>
                </div>
                <div
                    class="float-right"
                    v-if="fetchReturnPolicy.length > perPage"
                >
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="filterCount"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                    ></b-pagination>
                </div>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import { mapState } from "vuex";
import loader from "@/components/loader/nipigeloader.vue";
import moment from "moment";
import ComponentHeader from "@/components/componentNewHeader/index.vue";
export default {
    name: "Return  & Cancellation Policy",
    components: {
        ComponentHeader,
        loader,
    },
    data() {
        return {
            filterCount: 0,
            filter: "",
            loading: false,
            perPage: 10,
            currentPage: 1,
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            dark: false,
            sortBy: "createdAt",
            sortDesc: true,
            returnPolicyFields: [
                {
                    key: "refundMode",
                    label: "Refund Mode",
                },
                {
                    key: "createdAt",
                    label: "Created Date",
                },
                {
                    key: "allowCancellation",
                    label: "Allow Cancellation",
                },
                {
                    key: "returnWindowDays",
                    label: "Return/Replacement Window(in Days)",
                },

                {
                    key: "action",
                    label: "Action",
                    thStyle: { width: "8%" },
                },
            ],
        };
    },
    computed: {
        ...mapState({
            fetchReturnPolicy: (state) => state.returnPolicy.returnPolicy,
        }),
    },
    methods: {
        async getReturnPolicyList() {
            this.loading = true;
            try {
                await this.$store.dispatch(
                    "returnPolicy/fetchReturnPolicyAction",
                );
            } catch (error) {
                this.$toasted.error("Unable to fetch data");
            } finally {
                this.loading = false;
            }
        },
        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },
        async deleteReturnPolicy(data) {
            this.$swal({
                title: "Delete this Policy?",
                text: "Are you sure? This will be Remove?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes, Delete it!",
                cancelButtonColor: "#d33",
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    this.loading = true;
                    this.$store
                        .dispatch(
                            "returnPolicy/deleteReturnPolicyAction",
                            data._id,
                        )
                        .then((result) => {
                            this.$swal({
                                type: "success",
                                title: "Success",
                                text: "Policy Deleted Successfully!",
                            });
                            this.getReturnPolicyList();
                            this.loading = false;
                        });
                }
            });
        },
        async returnPolicyView(data) {
            this.$router.push({
                name: "View Return Policy",
                params: { id: data._id },
            });
        },
        async returnPolicyEdit(data) {
            this.$router.push({
                name: "Edit Return Policy",
                params: { id: data._id },
            });
        },
    },
    filters: {
        formatedate: function (value) {
            if (value) {
                return moment(String(value)).format("DD-MMM-YYYY hh:mm A");
            }
        },
    },

    async mounted() {
        this.getReturnPolicyList();
    },
};
</script>
<style scoped></style>
